import { useMutation, useQueryClient } from '@tanstack/react-query';

import { coreApi } from '../api';
import { coreKeys } from '../query-key-factory';
import { ICredential } from './paymentMethods.types';

export const useCreatePaymentMethod = () => {
  const queryClient = useQueryClient();

  const create = async (form: {
    email: string | null;
    card_token: string;
    save_for_future_use: boolean;
    enroll_in_shop_to_give: boolean;
  }) => {
    const { data } = await coreApi.post<{ credential: ICredential }>(`/v2/payment_methods`, {
      credential: form,
    });
    return data.credential;
  };

  return useMutation({
    mutationFn: create,
    mutationKey: coreKeys.user.paymentMethods.all,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: coreKeys.user.paymentMethods.all });
    },
  });
};
